<template>
	<div id="affiliates-page" class="affiliates-page">

		<!-- <section class="breadcrumb-section">
			<div class="container oversized-container">
				<span>Home</span>
				<span class="line">/</span>
				<span>Afiliados</span>
			</div>
		</section> -->

		<section class="container oversized-container products-section">
			<h1>Afiliados</h1>

			<div class="center-in-view" v-if="!catalogIsLoaded">
				<ui-spinner />
			</div>
			
			<div class="affiliates-catalog" v-else-if="cCatalogSellers.length">
				<div class="flex-container" v-for="(seller, pInx) in cCatalogSellers" :key="'pInx-' + pInx">
					<router-link class="outlined-box" :to="{ name: 'AfiliadoShowroom', params: {id: seller.vendedores_id} }">

						<div class="box-image">
							<div class="img">
								<img src="/public/images/shared/product.png" v-bind:style="{ backgroundImage: 'url(' + seller.logo + ')'}" />
							</div>
						</div>

						<div class="box-shot-descr">
							<h6 class="name">{{ seller.nombre }}</h6>
						</div>

					</router-link>
				</div>
			</div>

			<h5 v-else>
				No se encontraron resultados
			</h5>
		</section>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {

	data() {
		return {
			products: [
				// { id: 1, img: 'public/images/logo-web.png', name: 'Nombre del afiliado' },
				{
					id: 1,
					img: "public/images/logo-web.png",
					name: "Nombre del afiliado",
				},
			],
		};
	},

	computed: {
		...mapGetters(['catalogSellers', 'catalogIsLoaded']),
		cCatalogSellers(){
			return _.take(this.$store.getters.catalogSellers, 3);
		}
	},

	methods: {},

	mounted() {},
};
</script>

<style lang="scss">
	@import '@/sass/utils/_variables';
	#affiliates-page{
		.center-in-view {
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 30vh;
		}
		h1, h5 {
			text-align: center;
		}
		h1 {
			margin-top: 1em;
		}
		min-height: 74vh;

		.affiliates-catalog {

			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: stretch;
			gap: 1rem;

			margin-top: 2em;
			margin-bottom: 3em;

			.flex-container {
				flex: 0 1 calc(25% - 4em);

				.outlined-box {
					display: flex;
					flex-flow: column;
					padding: 0.5rem;
					text-decoration: none;
					color: inherit;
					border: $general-border;
					border-radius: 6px;
					padding: 5px;
	
					&:hover {
						background-color: $secondary-transparent;
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					}
	
					h6 {
						text-align: center;
						padding: 10px 0;
					}
					.box-image {
						.img {
							width: 100%;
							height: auto;
							border-radius: 4px;
							overflow: hidden;
		
							img {
								display: block;
								width: 100%;
								height: 100%;
								background-size: cover;
								background-position: center;
								object-fit: cover;
							}
						}
					}
				}
			}

		}

		h6 {
			color: $green;
		}

		@media screen and (max-width: 480px) {
			.affiliates-catalog {
				.flex-container {
					flex: 1 1 auto !important;
				}
			}
		}
		@media screen and (max-width: 991px) {
			.affiliates-catalog {
				.flex-container {
					flex: 0 1 calc(50% - 4em);
				}
			}
		}
	}
</style>